import {useQuery} from "react-query";
import {NotificationSearchRequest} from "../../models/notification";
import notificationService from "../../services/NotificationService";

export default function useNotifications(request?: NotificationSearchRequest) {
   return useQuery(['notifications', request], () => notificationService.search(request));
}